import { FORGET_USER, FORGET_USER_SUCCESSFUL, FORGET_PASSWORD_API_FAILED, RESET_FORGOT_PW_STATE } from './actionTypes';

export const forgetUser = (payload) => {
  
    return {
        type: FORGET_USER,
        payload: payload
    }
}

export const forgetUserSuccessful = (message) => {
    return {
        type: FORGET_USER_SUCCESSFUL,
        payload: message
    }
}

export const userForgetPasswordError = (error) => {
    return {
        type: FORGET_PASSWORD_API_FAILED,
        payload: error
    }
}
// ====================================================================================================================

export const resetForgetPWState = () => {
    return {
         type: RESET_FORGOT_PW_STATE,
         playload:{}
    }
}
